import olimp from '../config/olimp/locale'
import olimpbet from '../config/olimpbet/locale'
import olymp from '../config/olymp/locale'

export function getLocalePolicy(settings) {
  const factory = { olymp, 'olymp-latam': olymp, olimp, olimpnew: olimp, olimpbet }[settings.platform] || olymp
  return factory(settings)
}
